import React from 'react';
import { SubHeader } from '../../uiComponents';
import { useTranslation } from 'react-i18next';
import { DocumentListTableWrapper } from './DocumentListTable';

export const DocumentList = (props) => {
  const { t } = useTranslation();
  const leftContent = {
    title: t('documentList.title'),
    breadcrumb: '',
  };
  return (
    <div className="bg_blue p-3 content">
      <div className="mt-2 pb-2">
        <SubHeader isDisplay={false} leftContent={leftContent} />
        <div className="bg-white p-3">
          <DocumentListTableWrapper t={t} userId={props?.userId}/>
        </div>
      </div>
    </div>
  );
};
